module.exports = "//public.zight.com/packs/media/images/analytics-e2b25319fa9540e8b2711658cdda55bc.svg";